import { filter } from 'lodash';

import {
  EnquiryProductConfig,
  Proposal,
  QUOTE_RESPONSE_ACTIONS,
  QuoteResponseAction,
} from '@lockton-apps/shared/interfaces';

export const DISPATCH_ACTIONS = {
  PatchInitialized: 'patch-initialized',
  AdjustmentUpdate: 'adjustment-update',
  EndorsementUpdate: 'endorsement-update',
  SendRenewalInvite: 'send-renewal-invite',
  ProposalUpdate: 'proposal-update',
  ProposalSubmit: 'proposal-submit',
  Update: 'update',
  Return: 'return',
  Hold: 'hold',
  Requote: 'requote',
  QuoteRequest: 'quote-request',
  QuoteReady: 'quote-ready',
  Send: 'send',
  Accept: 'accept',
  Invoice: 'invoice',
  SetPaymentType: 'set-payment-type',
  PaymentReceived: 'payment-received',
  Complete: 'complete',
  NotTakenUp: 'not-taken-up',
} as const;

export type DispatchAction =
  (typeof DISPATCH_ACTIONS)[keyof typeof DISPATCH_ACTIONS];

export type PatchPayload = object | undefined;
export type ProposalUpdateData = Omit<Proposal, 'id'> & { proposalId: string };
export type ProposalSubmitData = Omit<Proposal, 'id'> & { proposalId: string };
export type PatchInitializeData = { selectedProducts: EnquiryProductConfig[] };

export const registeredApiActions = Object.values(QUOTE_RESPONSE_ACTIONS);

export function filterRegisteredApiActions(
  actions: QuoteResponseAction[]
): QuoteResponseAction[] {
  return filter(actions, (action) =>
    registeredApiActions.includes(action.type)
  );
}
